import { Cookies } from 'quasar'
import Model from 'src/models/model'
import { ORDER_STATES } from 'src/models/order/Order'

/** @typedef {import('vue-router').NavigationGuard} NavigationGuard */

/** @type {NavigationGuard} */
export async function updateGlobalShowingIdHeader (to, _from, next) {
  Model.app.$updateGlobalHeaders({ 'showing-id': to.params.id })
  await Model.ensureBooted()
  return next()
}

/** @type {NavigationGuard} */
export async function updateGlobalActivityIdHeader (to, _from, next) {
  Model.app.$updateGlobalHeaders({ 'activity-id': to.params.id })
  await Model.ensureBooted()
  return next()
}

/** @type {NavigationGuard} */
export async function leaveCheckoutIfOrderIsCompleted (to, _from, next) {
  if (_.endsWith(to.name, ':payment')) {
    // This route shouldn't be added to on the last step of checkout route,
    // but just in case, we should allow it.
    return next()
  }

  const order = Model.app.config.globalProperties.$order
  if (order?.isRemote && order.state === ORDER_STATES.COMPLETED) {
    const orderUser = order.user
    const moviePagePath = order.currentShowing?.movie?.pagePath

    // Similar to CheckoutLayout leaveCheckout method
    order.reset()
    if (orderUser?.isRemote) {
      order.setRelated('user', orderUser)
    }
    const constants = Model.app.config.globalProperties.$constants
    if (Cookies.has(constants.cookies.alcoholAcknowledgement)) {
      Cookies.remove(constants.cookies.alcoholAcknowledgement)
    }

    if (localStorage.getItem(constants.localStorageKeys.seatChartConfirmations)) {
      localStorage.removeItem(constants.localStorageKeys.seatChartConfirmations)
    }

    if (moviePagePath) {
      return next({ path: moviePagePath })
    } else {
      return next({ path: '/' })
    }
  }

  return next()
}
